import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';

import {
    Table, TableHead, TableRow, TableCell, TableBody, Typography, TableFooter, TablePagination,
} from '@material-ui/core';

import * as PageSettingStore from '../../app/store/PageSettingStore';
import urls from '../../app/urls';
import {
    InfoMessage, SortableTableCell,
} from '../../common/components';

import { sortByColumn } from '../../youwell-common/tableUtils';
import { defaultRowsPrPage, userSortColumns } from '../../common/constants';
import UserListFilter from './components/UserListFilter';
import { caseInsensitiveContains } from '../../youwell-common/stringUtils';

const styles = theme => ({
    root: {
    },
    table: {
        '& td': {
            border: 0,
            paddingLeft: 0,
        },
    },
    headerRow: {
        height: theme.spacing(4),
    },
    headerCell: {
        padding: 0,
        fontSize: theme.typography.subtitle2.fontSize,
        fontWeight: theme.typography.subtitle2.fontWeight,
        color: theme.palette.text.primary,
        borderBottomColor: theme.palette.secondary.main,
    },
    row: {
        height: theme.spacing(8),
        borderBottom: theme.borders.normal,
        cursor: 'pointer',

        '&:hover': {
            background: theme.palette.grey[100],
            borderBottomColor: theme.palette.secondary.main,
        },
    },
    hiddenOnSmall: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    mainNameText: {
        fontSize: theme.typography.subtitle2.fontSize,
        fontWeight: theme.typography.subtitle2.fontWeight,
        display: 'flex',
        alignItems: 'center',
    },
    chip: {
        marginLeft: theme.spacing(1),
    },
    icon: {
        marginLeft: theme.spacing(1),
        color: theme.palette.text.secondary,
    },
    spacingCell: {
        width: theme.spacing(8),
        padding: 0,

        [theme.breakpoints.down('md')]: {
            width: theme.spacing(4),
        },

        [theme.breakpoints.down('sm')]: {
            width: theme.spacing(2),
        },

        [theme.breakpoints.down('xs')]: {
            width: 0,
        },
    },
    paginationSelect: {
        paddingRight: theme.spacing(3),
    },
    filter: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4),
    },
    actions: {
        marginTop: theme.spacing(6),
    },
});


class UserList extends React.Component {
    handleChangePage = (event, page) => {
        this.props.setUserPage(page);
    }

    handleChangeRowsPerPage = (event) => {
        this.props.setUserRowsPerPage(event.target.value);
    }

    redirect = to => () => {
        this.props.redirect(to);
    }

    onfilterUpdate = (filter) => {
        this.props.setUserFilter(filter);
    }

    filterUsers = (user) => {
        const { filter } = this.props;
        if (!filter) {
            return true;
        }
        if (filter.search) {
            let result = true;
            result = caseInsensitiveContains(user.name, filter.search.toLowerCase());
            if (!result) {
                return false;
            }
        }
        if (filter.role) {
            if (user.roles?.indexOf(filter.role) < 0) {
                return false;
            }
        }

        return true;
    };

    render() {
        const {
            classes, translate, userList, rowsPerPage, page, sorting, filter,
        } = this.props;

        const filteredUsers = sortByColumn(userList, sorting)
            .filter(this.filterUsers);

        return (
            <div className={classes.root}>
                <UserListFilter filter={filter} className={classes.filter} onUpdate={this.onfilterUpdate} />

                {filteredUsers.length === 0 ? (
                    <InfoMessage message={translate('user.noUsersFound')} />
                ) : (
                    <Table
                        className={classes.table}
                    >
                        <TableHead>
                            <TableRow className={classes.headerRow}>
                                <TableCell className={classes.headerCell} />
                                <SortableTableCell className={classes.headerCell} columnName={userSortColumns.name} label={translate('user.name')} sorting={sorting} onSort={this.props.setUserSorting} />
                                <SortableTableCell className={classes.headerCell} columnName={userSortColumns.role} label={translate('user.role')} sorting={sorting} onSort={this.props.setUserSorting} />
                                <SortableTableCell className={classes.headerCell} columnName={userSortColumns.email} label={translate('user.email')} sorting={sorting} onSort={this.props.setUserSorting} />
                                <SortableTableCell className={classes.headerCell} columnName={userSortColumns.phone} label={translate('user.phone')} sorting={sorting} onSort={this.props.setUserSorting} />
                                {/* <SortableTableCell className={classes.headerCell} columnName={userSortColumns.updated} label={translate('user.lastUpdated')} dataType={sortDataType.date} sorting={sorting} onSort={this.props.setUserSorting} /> */}
                                <TableCell className={classes.headerCell} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredUsers
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(item => (
                                    <TableRow className={classes.row} key={`${item.id}_${item.role}`} onClick={this.redirect(`${urls.inside.users.home}/${item.id}`)}>
                                        <TableCell className={classes.spacingCell} />
                                        <TableCell>
                                            <Typography className={classes.mainNameText}>
                                                {item.name}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>
                                                {item.roles?.map(role => translate(`user.appRoles_${role}`, null, { onMissingTranslation: () => '' })).join(', ')}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>
                                                {item.email}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>
                                                {item.phone}
                                            </Typography>
                                        </TableCell>
                                        {/* <TableCell>
                                            <Typography>
                                                {timestamp(item.updated)}
                                            </Typography>
                                        </TableCell> */}
                                        <TableCell className={classes.spacingCell} />
                                    </TableRow>
                                ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                {filteredUsers.length > defaultRowsPrPage && (
                                    <TablePagination
                                        count={filteredUsers.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        rowsPerPageOptions={[15, 30, 50]}
                                        labelRowsPerPage={translate('user.rowsPerPage')}
                                        labelDisplayedRows={displayedRows => translate('user.displayedRows', displayedRows)}
                                        classes={{ select: classes.paginationSelect }}
                                    />
                                )}
                            </TableRow>
                        </TableFooter>
                    </Table>
                )}
            </div>
        );
    }
}


UserList.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    userList: PropTypes.array,
    // clientConfig: PropTypes.object.isRequired,
    redirect: PropTypes.func.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    setUserRowsPerPage: PropTypes.func.isRequired,
    setUserSorting: PropTypes.func.isRequired,
    setUserFilter: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    setUserPage: PropTypes.func.isRequired,
    sorting: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
};

UserList.defaultProps = {
    userList: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    userList: state.user.list,
    clientConfig: state.auth.clientConfig,
    rowsPerPage: state.pageSettings.userRowsPerPage,
    page: state.pageSettings.userPage,
    sorting: state.pageSettings.userSorting,
    filter: state.pageSettings.userFilter,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PageSettingStore.actionCreators, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserList));
